/**
 * 受付帳（ReceptionBook）用の備考同期システム
 * PropertySelectionGridと受付帳ポップアップ間で備考データを同期するためのユーティリティ
 */

import { createIndexedPropertyGridPopupSyncSystem } from "./createSyncSystem";

export const RECEPTION_BOOK_REMARKS_UPDATE_EVENT = "updateReceptionBookRemarks";

const { dispatch, addListener } =
  createIndexedPropertyGridPopupSyncSystem<string>(
    RECEPTION_BOOK_REMARKS_UPDATE_EVENT
  );

/**
 * 受付帳の備考更新イベントを発火する
 * @param index 受付帳のインデックス
 * @param remarks 更新する備考
 */
export const dispatchReceptionBookRemarksUpdate = (
  index: number,
  remarks: string
): void => {
  dispatch(index, remarks);
};

/**
 * 受付帳の備考更新イベントリスナーを追加する
 * @param targetIndex リスナーを登録する対象のインデックス
 * @param callback 備考が更新された際に呼び出されるコールバック関数
 * @returns クリーンアップ関数
 */
export const addReceptionBookRemarksUpdateListener = (
  targetIndex: number,
  callback: (remarks: string) => void
): (() => void) => {
  return addListener(targetIndex, callback);
};
